import { render, staticRenderFns } from "./UebSettings.vue?vue&type=template&id=042f5bd8&scoped=true&"
import script from "./UebSettings.vue?vue&type=script&lang=js&"
export * from "./UebSettings.vue?vue&type=script&lang=js&"
import style0 from "./UebSettings.vue?vue&type=style&index=0&id=042f5bd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042f5bd8",
  null
  
)

export default component.exports